module.exports = __webpack_public_path__ + "static/media/p03.01ec52e8.png";